import DatetimeUtils from "../datetime-utils"

const debug = false
// const debug = "isSameValue"

export default function isSameValue(model: any, paramName:string, value:any) {
    if (moment.isMoment(model[paramName])) {
        debug && console.log(debug, "process moment", DatetimeUtils.momentToDate(model[paramName]), DatetimeUtils.dateTruncTime(value), DatetimeUtils.isSame(model[paramName], DatetimeUtils.dateToMoment(value), 'day'))
        return DatetimeUtils.isSame(model[paramName], DatetimeUtils.dateToMoment(value), 'day')
    } else {
        return _.isEqual(model[paramName],value)
    }
}